/** @jsx jsx */
import React from "react";
import { jsx } from "theme-ui";

const BenefitsPardot = () => {
  const [modalIsOpen, setIsOpen] = React.useState(false);

  function openModal() {
    setIsOpen(true);
  }

  function closeModal() {
    setIsOpen(false);
  }

  return (
    <div>
      <div className="cta">
        <div
          onClick={openModal}
          sx={{
            cursor: "pointer",
            textDecoration: "underline",
            color: "primary",
          }}
        >
          Get your copy now
        </div>
      </div>
      <div
        sx={{
          display: modalIsOpen ? "block" : "none",
          position: "fixed",
          inset: "0px",
          backgroundColor: "rgba(255, 255, 255, 0.75)",
          zIndex: "100",
        }}
      >
        <div
          className="custom-pardot-modal"
          sx={{
            position: "absolute",
            inset: "50% auto auto 50%",
            border: "1px solid rgb(204, 204, 204)",
            background: "rgb(255, 255, 255)",
            overflow: "auto",
            borderRadius: "8px",
            outline: "none",
            padding: "0px 40px",
            marginRight: "-50%",
            transform: "translate(-50%, -50%)",
            width: "90%",
            maxWidth:"900px",
            boxSizing: "border-box",
            maxHeight:"100%",
          }}
        >
          <div
            sx={{
              cursor: "pointer",
              position: "absolute",
              right: "15px",
              top: "15px",
            }}
            onClick={closeModal}
          >
            <svg
              width="20"
              height="20"
              viewBox="0 0 20 20"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <g clip-path="url(#clip0_1125_63)">
                <path
                  d="M10.8839 10.8839C11.372 10.3957 11.372 9.60427 10.8839 9.11612L2.92893 1.16117C2.44078 0.67301 1.64932 0.67301 1.16117 1.16117C0.67301 1.64932 0.67301 2.44078 1.16117 2.92893L8.23223 10L1.16117 17.0711C0.67301 17.5592 0.67301 18.3507 1.16117 18.8388C1.64932 19.327 2.44078 19.327 2.92893 18.8388L10.8839 10.8839ZM8.75 11.25H10V8.75H8.75V11.25Z"
                  fill="#14158B"
                />
                <path
                  d="M9.11612 9.11612C8.62796 9.60427 8.62796 10.3957 9.11612 10.8839L17.0711 18.8388C17.5592 19.327 18.3507 19.327 18.8388 18.8388C19.327 18.3507 19.327 17.5592 18.8388 17.0711L11.7678 10L18.8388 2.92893C19.327 2.44078 19.327 1.64932 18.8388 1.16117C18.3507 0.67301 17.5592 0.67301 17.0711 1.16117L9.11612 9.11612ZM11.25 8.75H10V11.25H11.25V8.75Z"
                  fill="#14158B"
                />
              </g>
              <defs>
                <clipPath id="clip0_1125_63">
                  <rect width="20" height="20" fill="white" />
                </clipPath>
              </defs>
            </svg>
          </div>
          <div
            sx={{
              display: "flex",
              flexWrap: "wrap",
              justifyContent: "space-between",
              alignItems: "flex-start",
              padding: "40px 0px",
            }}
          >
            <div
              sx={{
                width: ["100%"],
                iframe: {
                  height: "100%",
                  minHeight: ["710px","630px","630px"],
                },
              }}
              dangerouslySetInnerHTML={{
                __html: `
              <iframe data-src="https://www2.everplans.com/l/69022/2024-05-07/lx3hhv" class="optanon-category-C0003" width="100%" height="500" type="text/html" frameborder="0" allowTransparency="true" style="border: 0"></iframe>
          `,
              }}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default BenefitsPardot;
